
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inbox/[[...conversationSlug]]",
      function () {
        return require("private-next-pages/inbox/[[...conversationSlug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inbox/[[...conversationSlug]]"])
      });
    }
  